<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 配置-分类
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="filter_from" inline :model="filter_from">
          <el-form-item>
            分类:
            <el-input v-model="filter_from.name" value="" placeholder="输入分类名称进行搜索" style="width: 220px"></el-input>
          </el-form-item>
          <el-form-item>
            创建人:
            <el-input v-model="filter_from.created_by" value="" placeholder="输入创建人进行搜索" style="width: 220px"></el-input>
          </el-form-item>
          <el-form-item label="题材:"><el-select v-model="filter_from.subject_id" clearable filterable><el-option v-for="item in subjects" :key="item.id" :label="item.name" :value="item.id" /></el-select></el-form-item>
          <el-form-item label="项目组:"><el-select v-model="filter_from.project_team_code" clearable filterable><el-option v-for="item in projectTeams" :key="item.code" :label="item.name" :value="item.code" /></el-select></el-form-item>
          <el-form-item>
            上线状态:
            <el-select v-model="filter_from.is_show" value="" clearable placeholder="-----">
            <el-option
              v-for="item in status_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading.search" @click="search">查 询</el-button>
            <el-button type="primary"  @click="dialog.create_cate=true">添加分类</el-button>
          </el-form-item>
          <el-dialog title="添加分类" :visible.sync="dialog.create_cate" width="35%" :before-close="handle_close" :close-on-click-modal="false">
            <el-form  ref="form"  :model="form" label-width="110px">
                <el-form-item label="分类名称:" prop="name">
                  <el-input type="textarea" rows="3" v-model="form.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="题材:">
                  <el-select v-model="form.subject_id" clearable filterable @clear="form.subject_id = null"><el-option v-for="item in subjects" :key="item.id" :label="item.name" :value="item.id" /></el-select>
                </el-form-item>
                <el-form-item label="项目组:">
                  <el-select v-model="form.project_team_code" clearable filterable @clear="form.project_team_code = null"><el-option v-for="item in projectTeams" :key="item.code" :label="item.name" :value="item.code" /></el-select>
                </el-form-item>
                <el-alert v-if="directoryError" :title="directoryError" type="error" :closable="false" />
                <el-button v-if="directoryError" type="text" @click="loadOptions">重试加载题材/项目组</el-button>
            </el-form>
            <div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handle_close">取 消</el-button>
                <el-button type="primary" @click="create" :loading="loading.create_cate" :disabled="!!directoryError">确 定</el-button>
              </span>
            </div>
          </el-dialog>
          <el-dialog title="编辑分类" :visible.sync="dialog.update_cate" width="35%" :before-close="handle_close" :close-on-click-modal="false">
            <el-form  ref="form"  :model="update_form" label-width="110px">
                <el-form-item label="分类名称:" prop="name">
                  <el-input  v-model="update_form.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="题材:">
                  <el-select v-model="update_form.subject_id" clearable filterable @clear="update_form.subject_id = null"><el-option v-for="item in subjects" :key="item.id" :label="item.name" :value="item.id" /></el-select>
                </el-form-item>
                <el-form-item label="项目组:">
                  <el-select v-model="update_form.project_team_code" clearable filterable @clear="update_form.project_team_code = null"><el-option v-for="item in projectTeams" :key="item.code" :label="item.name" :value="item.code" /></el-select>
                </el-form-item>
                <el-alert v-if="directoryError" :title="directoryError" type="error" :closable="false" />
                <el-button v-if="directoryError" type="text" @click="loadOptions">重试加载题材/项目组</el-button>
            </el-form>
            <div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="handle_close">取 消</el-button>
                <el-button type="primary" @click="update" :loading="loading.update_cate" :disabled="!!directoryError">确 定</el-button>
              </span>
            </div>
          </el-dialog>
        </el-form>
      </div>
      <el-table
          :data="tableData"
          border
          class="table"
          row-key="id"
          ref="multipleTable"
        >
        <el-table-column prop="id" label="ID" align="center" ></el-table-column>
        <el-table-column prop="category_uid" label="分类UID" align="center" ></el-table-column>
        <el-table-column prop="name" label="分类名称" align="center" ></el-table-column>
        <el-table-column prop="subject_name" label="题材" :formatter="emptyValue" align="center" />
        <el-table-column prop="project_team_name" label="项目组" :formatter="emptyValue" align="center" />
        <el-table-column prop="current_daily_quantity" label="当前每日需求" :formatter="emptyValue" align="center" />
        <el-table-column prop="created_by" label="创建人" align="center" ></el-table-column>
        <el-table-column prop="update_date" label="更新时间" :formatter="formatProductionDateTime"  align="center" ></el-table-column>
        <el-table-column label="操作" align="center" min-width="260">
          <template slot-scope="scope">
            <el-button  type="primary"  @click="pre_update(scope.row)"  icon="el-icon-edit" size="mini">编辑</el-button>
            <el-button type="primary" @click="demandCategory = scope.row" size="mini">每日需求</el-button>
            <el-button type="danger" @click="remove(scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" >
           <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_show"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value=1
              @change="update_status(scope.row.id, scope.row.is_show)"
              :inactive-value=0>
            </el-switch>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <CategoryDemand v-if="demandCategory" :category="demandCategory" @close="demandCategory = null" @changed="search" />
    <div class="pagination">
        <el-pagination
                background
                @size-change="search"
                @current-change="search"
                :current-page.sync="cur_page"
                :page-size.sync="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total_count"
                :page-sizes="[10, 20, 40, 80]"
                align="center"
        ></el-pagination>
    </div>
  </div>
</template>

<script>
import { 
  production_list, production_create, production_update, production_delete,
  production_category_status, production_options,
 } from '../../api/getData'
import { productionError, validateCategoryName, formatProductionDateTime } from '@/utils/production'
import CategoryDemand from './CategoryDemand.vue'
import {page_constant} from '../../mixins/mixins'
export default {
  name: 'config_cate',
  components: { CategoryDemand },
  data() {
    return{
      subjects: [],
      projectTeams: [],
      directoryError: "",
      demandCategory: null,
      originalName: "",
      loading: {
        create_cate: false,
        update_cate: false,
        search: false,
      },
      dialog: {
        create_cate: false,
        update_cate: false,
      },
      tableData: [],
      ordering: "",
      status_options: [
        {
          value: 0,
          label: '下线'
        },
        {
          value: 1,
          label: '上线'
        }
      ],
      form: {
        name: "", subject_id: null, project_team_code: null
      },
      filter_from: {
        name: "",
        created_by:"",
        subject_id: "", project_team_code: "",
        is_show:"",

      },
      update_form: {
        id: "",
        name: "", subject_id: null, project_team_code: null,
      },
      ...page_constant
    }
  },
     
  async created() {
    await Promise.all([this.search(), this.loadOptions()])

  },
  computed: {
    offset() {
      return (this.cur_page - 1)*  this.size
    },
    limit() {
      return this.size
    }
  },
  methods: {
    formatProductionDateTime,
    emptyValue(row, column, value) { return value === null || value === undefined || value === '' ? '-' : value },
    async loadOptions() {
      try {
        const [subjects, teams] = await Promise.all([production_options('subject'), production_options('project_team')])
        this.subjects = subjects; this.projectTeams = teams; this.directoryError = ''
      } catch (error) { this.directoryError = productionError(error) }
    },
    async search(){
      this.loading.search = true
      try {
        const res = await production_list('category', {offset: this.offset, limit: this.limit, ordering: this.ordering, ...this.filter_from})
        this.tableData = res.results; this.total_count = res.count
      } catch (error) { this.$message.error(productionError(error)) }
      finally { this.loading.search = false }
    },
    set_properties(obj, value){
      Object.keys(obj).forEach(key => {
        obj[key] = value
      });
    },
    handle_close(){
      this.set_properties(this.dialog, false)
      this.set_properties(this.loading, false)
    },
    async create(){
      if (!validateCategoryName(this.form.name)) { this.$message.error('每个完整分类名最长32字符，使用 manual_ 或 auto_ 加小写字母、数字、下划线'); return }
      this.loading.create_cate = true
      try { await production_create('category', this.form); this.dialog.create_cate = false; await this.search() }
      catch (error) { this.$message.error(productionError(error)) }
      finally { this.loading.create_cate = false }
    },
    pre_update(row){
      this.update_form = {id: row.id, name: row.name, subject_id: row.subject_id, project_team_code: row.project_team_code}
      this.originalName = row.name
      this.dialog.update_cate = true
      this.loadOptions()
    },
    async update(){
      if (!validateCategoryName(this.update_form.name, this.originalName) || (this.update_form.name !== this.originalName && /[,，]/.test(this.update_form.name))) { this.$message.error('新分类名格式不正确，完整名称最长32字符'); return }
      this.loading.update_cate = true
      try {
        const {name, subject_id, project_team_code} = this.update_form
        await production_update('category', this.update_form.id, {name, subject_id, project_team_code})
        this.dialog.update_cate = false; await this.search()
      } catch (error) { this.$message.error(productionError(error)) }
      finally { this.loading.update_cate = false }
    },
    async update_status(id, is_show){
      try { await production_category_status(id, {is_show}); await this.search() }
      catch (error) { const row = this.tableData.find(item => item.id === id); if (row) row.is_show = is_show === 1 ? 0 : 1; this.$message.error(productionError(error)) }
    },
    async remove(row) {
      try { await this.$confirm(`删除分类“${row.name}”及全部需求分段？`, '确认删除'); await production_delete('category', row.id); await this.search() }
      catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(productionError(error)) }
    }

  }
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
